import { hex2rgb } from '@sainsburys-tech/boltui-utils'

const isMeasurement = (item: any[]): boolean => {
  const needsMeasurement = ['fontSize']
  return needsMeasurement.includes(item[0]) && item[1].indexOf('rem') === -1
}

const transformToCSS = (item: string): string => item.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase()

const createRGBparam = (hexValue: number | string | null): string =>
  hexValue ? `bg=${hex2rgb(hexValue.toString())}` : ''

const createPOIparam = (
  imageRatio: number | string | null,
  url?: string,
  breakpoints?: Record<string, string>,
  tabletImagePositionTop?: boolean,
  mobileImagePosition?: boolean,
  ratioInGrid?: string
): Array<Record<string, string | number | string[]>> | string => {
  const c001RatioMapping = {
    '2xs': !mobileImagePosition ? '4:5' : '3:2',
    xs: !mobileImagePosition ? '4:5' : '3:2',
    sm: imageRatio,
    md: imageRatio,
    lg: tabletImagePositionTop ? ratioInGrid : imageRatio,
    xl: tabletImagePositionTop ? ratioInGrid : imageRatio
  }

  // width to Number and poi logic to sit within Bolt image after test run
  const width = (breakpointWidth) => {
    const breakpointNumberWidth = breakpointWidth.split('p')[0]
    const shouldSplit = breakpointNumberWidth < 540 ? !mobileImagePosition : !tabletImagePositionTop
    return shouldSplit ? breakpointNumberWidth / 2.5 : breakpointNumberWidth / 2
  }
  const poiQuery = (ratio) =>
    `poi={$this.metadata.pointOfInterest.x},{$this.metadata.pointOfInterest.y},{$this.metadata.pointOfInterest.w},{$this.metadata.pointOfInterest.h}&scaleFit={($this.metadata.pointOfInterest.x>0)?$sfpoi:$sfcenter}&sm=aspect&aspect=${ratio}&sfcenter=center&sfpoi=poi`

  const templates =
    breakpoints &&
    Object.keys(breakpoints).map((breakpoint) => {
      return {
        src: url,
        query: `(max-width: ${breakpoints[breakpoint]})`,
        width: width(breakpoints[breakpoint]),
        templates: ['maxW=768', poiQuery(c001RatioMapping[breakpoint] || imageRatio)]
      }
    })

  return templates || poiQuery(imageRatio)
}

export { isMeasurement, transformToCSS, createRGBparam, createPOIparam }
